<template>
  <main>
    <div class="l-main-content__inner">
      <homework-scope-selection
        :is-show="isShowScopeSelection"
        :work="selectedWork"
        v-model:selectedQuestionSetIds="selectedQuestionSetIds"
        @fix="fixScope"
        @cancel="resetScope"
      ></homework-scope-selection>

      <div v-show="!isShowScopeSelection">
        <div class="c-page-header">
          <h1 class="c-page-header-title">宿題編集</h1>
          <!-- 戻る -->
          <div class="c-page-header__return">
            <a
              href="javascript:void(0);"
              class="c-button-white -return -teacher"
              @click="openBackToHomeworkListConfirmModal()"
              >
              <span class="label">戻る</span>
            </a>
          </div>
        </div>

        <form
          class="c-parts-box -white p-homework-form"
          @submit.prevent
        >

          <div v-if="homework !== null">
            <section>
              <!-- 宿題の状態 -->
                <div v-if="homework.status === '公開中'">
                  <p class="p-homework-form__status -release">公開中</p>
                </div>
                <div v-else-if="homework.status === '未公開'">
                  <p class="p-homework-form__status -unpublished">未公開</p>
                </div>
                <div v-else>
                  <p class="p-homework-form__status -end">終了</p>
                </div>

              <!-- 学年・学級 -->
              <fieldset>
                <p class="p-homework-form__title">学年・学級</p>
                <dl class="p-homework-form__list">
                  <!-- 学年 -->
                  <dt class="p-homework-form__subtitle">学年</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      学年を選択すると、その学年の学級が表示され選択できます。
                      <p class="u-text-alert">※宿題作成後は変更できません。</p>
                    </div>
                    <div
                        id="gradeSelect"
                        class="c-form-radio-area -disabled">
                      <label
                        v-for="academicYear in academicYears"
                        :key="academicYear.value"
                        class="c-form-radio"
                        :class="{ '-checked': academicYear.value === selectedAcademicYear }"
                        :for="`grade${academicYear.value}`"
                      >
                        <input type="radio"
                          name="grade"
                          :value="academicYear.value"
                          :id="`grade${academicYear.value}`"
                          class="c-form-radio__input"
                          disabled
                          v-model="selectedAcademicYear"
                        >
                        <span class="c-form-radio__label">{{ academicYear.value }}年生</span>
                      </label>
                    </div>
                  </dd>
                </dl>
              </fieldset>
              <!-- 学級 -->
              <fieldset id="classSelect" class="u-text-hidden-area display">
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">学級</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">学年全体や複数の学級を選択できます。</div>
                    <!-- 全学級チェックボックス -->
                    <label class="c-form-checkbox-area" for="class-all">
                      <input type="checkbox"
                        class="c-form-checkbox"
                        id="class-all"
                        :checked="isAllSelected"
                        @change="toggleAllClassrooms"
                      >
                      <span class="c-form-checkbox-label -large">全学級</span>
                    </label>
                    <!-- 個々の学級チェックボックス -->
                    <div class="p-homework-form__class">
                      <label
                        v-for="classroom in classrooms"
                        :key="classroom.value"
                        class="c-form-checkbox-area class-item"
                        :class="{ 'is-disabled': !isClassroomSelectable(classroom) }"
                        :for="`class${classroom.value}`"
                      >
                        <input type="checkbox"
                          name="grade"
                          :value="classroom.value"
                          :id="`class${classroom.value}`"
                          class="c-form-checkbox"
                          v-model="selectedClassrooms"
                          :disabled="!isClassroomSelectable(classroom)"
                          @change="selectClassroom"
                        >
                        <span class="c-form-checkbox-label -large">{{ classroom.name }}</span>
                        <!-- NFR-7417: 生徒未登録かつ未割当の学級はホバーで選択不可の理由を表示 -->
                        <span
                          v-if="!isClassroomSelectable(classroom)"
                          class="p-homework-form__class-tooltip"
                          role="tooltip"
                        >この学級には生徒が登録されていないため選択できません。</span>
                      </label>
                    </div>
                  </dd>
                </dl>
              </fieldset>
            </section>

            <!-- 基本情報 -->
            <section>
              <fieldset>
                <p class="p-homework-form__title">基本情報</p>
                <!-- 宿題タイトル -->
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">宿題タイトル</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      宿題タイトルは、生徒の画面に表示されます。
                    </div>
                    <div class="c-form-area-half">
                      <div class="c-form-textbox">
                        <input type="text"
                          name="name"
                          id="name"
                          class="c-form-textbox__input"
                          placeholder="例) 生物の観察と分類のしかた"
                          maxlength="30"
                          required
                          v-model="name"
                        >
                      </div>
                      <p class="c-form-note">※30文字以内</p>
                    </div>
                  </dd>
                </dl>
              </fieldset>
              <!-- 生徒へのメッセージ -->
              <fieldset>
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">生徒へのメッセージ<span class="c-form-optional">任意</span></dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      宿題に対して、注意事項などのメッセージを設定できます。宿題メッセージは、生徒の画面に表示されます。
                    </div>
                    <div class="c-form-textarea">
                      <textarea
                        class="c-form-textarea__input"
                        id="message"
                        name="message"
                        placeholder="例）分からないときは教科書を確認して、全問正解を目指そう。"
                        maxlength="100"
                        v-model="message"
                      ></textarea>
                      <p class="c-form-note">※100文字以内（改行可能）</p>
                    </div>
                  </dd>
                </dl>
              </fieldset>
            </section>

            <!-- 範囲選択 -->
            <section>
              <!-- 教科選択 -->
              <fieldset>
                <p class="p-homework-form__title">範囲選択</p>
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">教科</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      教科を選択すると、教材名が表示されます。
                      <p class="u-text-alert">※宿題作成後は変更できません。</p>
                    </div>
                    <div class="c-form-radio-area -disabled" id="subjectSelect">
                      <label
                        v-for="subject in subjects"
                        :key="subject.id"
                        :for="subjectNameValueMap[subject.name]"
                        class="c-form-radio"
                        :class="{ '-checked': subject.id === selectedSubjectId }"
                        >
                        <input type="radio"
                          name="subject"
                          :value="subject.id"
                          :id="subjectNameValueMap[subject.name]"
                          class="c-form-radio__input"
                          v-model="selectedSubjectId"
                          disabled
                        >
                        <span class="c-form-radio__label">{{ subject.name }}</span>
                      </label>
                    </div>
                  </dd>
                </dl>
              </fieldset>
              <!-- 教材選択 -->
              <fieldset id="subjecMaterial" class="u-text-hidden-area display">
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">教材名</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      <p class="u-text-alert">※宿題作成後は変更できません。</p>
                    </div>
                    <select-single
                      :options="works"
                      v-model:selected="selectedWorkId"
                      :init-blank="false"
                      :is-disabled="true"
                      @change="clearScope"
                    ></select-single>
                  </dd>
                </dl>
              </fieldset>
              <!-- 対象問題 -->
              <fieldset>
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">対象問題</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      「範囲選択」ボタンをクリックし、対象となる問題を選択してください。
                    </div>
                    <div class="p-homework-form__select-area">
                      <!-- FIXME NFR-4166: 別タブで表示する -->
                      <a
                        href="javascript:void(0);"
                        :class="{'c-button-blue -prefix-icon -homework p-homework-form__select-area-button': true, '-disabled': !selectedWorkId}"
                        @click="showScopeSelection"
                      >
                        <span class="label">範囲選択</span>
                      </a>
                      <plain-text-view
                        :markdown-text="selectedScope.title"
                        :prefix="`${selectedScope.prefix}`"
                      ></plain-text-view>
                    </div>
                  </dd>
                </dl>
              </fieldset>
            </section>

            <!-- 実施期間 -->
            <section>
              <fieldset>
                <p class="p-homework-form__title">実施期間</p>
                <p class="p-homework-form__text -independent">
                  生徒が宿題に取り組める期間を設定してください。
                  <span class="u-text-alert caution">※開始日時を変更しても、既に学習済みの生徒の宿題の進捗は変わりません。</span>
                </p>
                <!-- 開始日時 -->
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">開始日時</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__date-time">
                      <div class="c-form-textbox">
                      <input type="datetime-local"
                        placeholder=" "
                        value=""
                        class="c-form-textbox__input"
                        :min="minStartDateTime"
                        :max="maxStartDateTime"
                        required
                        autocomplete="off"
                        v-model="startDateTime"
                      >
                    </div>
                    </div>
                  </dd>
                </dl>
                <!-- 終了日時 -->
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">終了日時</dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__date-time">
                      <div class="c-form-textbox">
                        <input type="datetime-local"
                          placeholder=" "
                          value=""
                          class="c-form-textbox__input"
                          :min="minEndDateTime"
                          :max="maxEndDateTime"
                          required
                          autocomplete="off"
                          v-model="endDateTime"
                        >
                      </div>
                    </div>
                  </dd>
                </dl>
              </fieldset>
            </section>

            <!-- 達成条件・再学習指示 -->
            <section>
              <fieldset>
                <p class="p-homework-form__title">達成条件・再学習指示</p>
                <p class="p-homework-form__text -independent">
                  <span class="u-text-alert caution">※達成条件・再学習指示を変更しても、既に学習済みの生徒の宿題の進捗は変わりません。</span>
                </p>
                <!-- 達成条件 -->
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">達成条件</dt>
                  <dd class="p-homework-form__contents">
                    <div class="c-form-radio-area">
                      <label
                          v-for="achievementCondition in achievementConditions"
                          :key="achievementCondition.value"
                          class="c-form-radio"
                          :for="`achievement${achievementCondition.value}`"
                      >
                        <input type="radio"
                          name="achievement"
                          :value="achievementCondition.value"
                          :id="`achievement${achievementCondition.value}`"
                          class="c-form-radio__input"
                          required
                          v-model="selectedAchievementCondition"
                        >
                          <span class="c-form-radio__label">{{ achievementCondition.name }}</span>
                      </label>
                    </div>
                  </dd>
                </dl>
              </fieldset>
              <!-- 再学習指示 -->
              <fieldset>
                <dl class="p-homework-form__list">
                  <dt class="p-homework-form__subtitle">再学習指示<span class="c-form-optional">任意</span></dt>
                  <dd class="p-homework-form__contents">
                    <div class="p-homework-form__text">
                      開始日時以前の学習を「宿題の達成」として認めない場合、「宿題の開始日時前に学習済みでも、再度学習させる」をチェックしてください。
                    </div>
                    <label class="c-form-checkbox-area" for="relearning">
                      <input type="checkbox"
                        class="c-form-checkbox"
                        id="relearning"
                        v-model="relearningRequired"
                      >
                      <span class="c-form-checkbox-label -large">宿題の開始日時前に学習済みでも、再度学習させる</span>
                    </label>
                  </dd>
                </dl>
              </fieldset>

              <!-- 更新ボタン -->
              <p class="p-homework-form__button">
                <button type="button"
                  class="c-button-blue -small-regular"
                  :class="{ '-disabled': !hasUpdated }"
                  id="homeworkButton"
                  @click="updateHomework"
                >
                  <span class="label">更新する</span>
                </button>
              </p>
            </section>
          </div>
        </form>

        <!-- 更新中モーダル -->
        <in-progress-modal
          :is-open="isOpenAddInProgressModal"
          text="更新中"
        >
          ただいま宿題更新中です。作成完了後、宿題一覧に表示されます。<br>
          ※この処理には時間がかかる場合があります。画面を閉じずにこのままお待ちください。
        </in-progress-modal>

        <!-- エラーモーダル -->
        <error-modal></error-modal>
      </div>

      <!-- 離脱注意モーダル -->
      <confirm-red-modal
        :isOpen="isOpenMovePageConfirmModal"
        okLabel="このページから移動する"
        cancelLabel="このページに留まる"
        @ok="movePage"
        @cancel="closeMovePageConfirmModal"
      >
        <template v-slot:text> このページから移動しますか？</template>
        <template v-slot:alertText>移動した場合、変更は保存されません。</template>
      </confirm-red-modal>

    </div>
  </main>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from "vue";
  import { IAcademicYearClass, IYearClassClassroom } from "@/consts/interfaces";
  import { SUBJECTS } from "@/consts/subject";
  import { ACHIEVEMENT_CONDITION, INFOTOAST_MESSAGE_PARAMNAME } from "@/consts/homework";
  import { useHomeworkStore } from "@/store/teacher/homework_store";
  import { useLearningProgressStore } from "@/store/teacher/learning_progress_store";
  import { useWorkStore } from "@/store/teacher/work_store";

  const homeworkStore = useHomeworkStore()
  const learningProgressStore = useLearningProgressStore()
  const workStore = useWorkStore()

  const academicSessionId = ref<number>(null);
  const academicYears = ref<Array<any>>(null);
  const selectedAcademicYear = ref<number>(null);
  const academicYearsClassrooms = ref<IAcademicYearClass>(null);
  const classrooms = ref<Array<IYearClassClassroom>>([]);
  const isAllSelected = ref(false);
  const selectedClassrooms = ref<Array<number>>([]);
  // NFR-7417: 編集開始時点で既に割り当て済みの学級UUID。
  // 生徒0人になっていても、既割当のものは選択解除できるよう選択可能なままにする。
  const initiallySelectedClassrooms = ref<Set<string>>(new Set());
  const name = ref("");
  const message = ref("");
  const subjects =  ref<Array<any>>(null);
  const selectedSubjectId =  ref<number|string>('');
  const works = ref<Array<any>>([]);
  const selectedWorkId = ref<number|string>('');
  const selectedQuestionSetIds = ref<Array<number>>([]);
  const startDateTime = ref(null);
  const endDateTime = ref(null);
  const achievementConditions =  ref(ACHIEVEMENT_CONDITION)
  const selectedAchievementCondition = ref(1);
  const relearningRequired = ref(false);
  const homework = ref(null);
  const homeworkUpdateResult = ref(null);
  const isFetchedHomework = ref(false)
  const isOpenMovePageConfirmModal = ref(false);
  const location = ref("");
  const isShowScopeSelection = ref(false);
  const isOpenAddInProgressModal = ref(false);

  const subjectNameValueMap = computed(() => {
    let newSubjects = {}
    SUBJECTS.forEach(subject => newSubjects[subject.name]=subject.value)
    return newSubjects
  })

  // 選択された教材を返す
  const selectedWork = computed(() => {
    return works.value?.find(work => work.value === selectedWorkId.value) || null
  })

  // 選択された対象問題を返す
  const selectedScope = computed((): { prefix: string; title: string } => {
    const noScope = { prefix: "", title: "" }

    if (
      !selectedWorkId.value
        || selectedQuestionSetIds.value.length === 0
        || !selectedWork.value
    ) {
      return noScope
    }

    for (const part of selectedWork.value.parts) {
      for (const chapter of part.chapters) {
        for (const section of chapter.sections) {
          for (const questionSet of section.question_sets) {
            if (selectedQuestionSetIds.value.length === 1) {
              if (questionSet.id === selectedQuestionSetIds.value[0]) {
              // 選択された出題単位が1つの場合: {孫項目.sort_order} {選択した出題単位の孫項目名}
              // 例: 「1 身近な生物の観察/生物の特徴と分類」
                return {prefix: section.sort_order, title: section.title}
              }
            } else {
              // 複数の場合: {孫項目.sort_order} {選択した出題単位群の先頭孫項目名} + 他
              // 例: 「1 身近な生物の観察/生物の特徴と分類 + 他」
              if (selectedQuestionSetIds.value.includes(questionSet.id)) {
                return {prefix: section.sort_order, title: `${section.title} + 他`}
              }
            }
          }
        }
      }
    }
    return noScope
  })

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // カレンダーで選択可能な開始日時の最小値 (現在時以降) を設定する
  const minStartDateTime = computed(() => {
    let today = new Date()
    let year = today.getFullYear()
    let thisMonth = today.getMonth() + 1
    let month = thisMonth.toString().padStart(2, "0")
    let date = today.getDate().toString().padStart(2, "0")
    let hour = today.getHours().toString().padStart(2, "0")
    let minutes = today.getMinutes().toString().padStart(2, "0")
    return `${year}-${month}-${date}T${hour}:${minutes}`
  })

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // カレンダーで選択可能な開始日時の最大値 (現在日時〜1年先まで) を設定する
  const maxStartDateTime = computed(() => {
    let today = new Date()
    let year = today.getFullYear() + 1
    let thisMonth = today.getMonth() + 1
    let month = thisMonth.toString().padStart(2, "0")
    let date = today.getDate().toString().padStart(2, "0")
    let hour = today.getHours().toString().padStart(2, "0")
    let minutes = today.getMinutes().toString().padStart(2, "0")
    return `${year}-${month}-${date}T${hour}:${minutes}`
  })

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // カレンダーで選択可能な終了日時の最小値 (開始日時から1分後) を設定する
  const minEndDateTime = computed(() => {
    let start_date_time = new Date(startDateTime.value)
    start_date_time.setMinutes(start_date_time.getMinutes() + 1)
    let year = start_date_time.getFullYear()
    let this_month = start_date_time.getMonth() + 1
    let month = this_month.toString().padStart(2, "0")
    let date = start_date_time.getDate().toString().padStart(2, "0")
    let hour = start_date_time.getHours().toString().padStart(2, "0")
    let minutes = start_date_time.getMinutes().toString().padStart(2, "0")
    let min_end_datetime = `${year}-${month}-${date}T${hour}:${minutes}`
    return min_end_datetime
  })

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // カレンダーで選択可能な終了日時の最大値 (終了日時の最小値〜1年先まで) を設定する
  const maxEndDateTime = computed(() => {
    let end_date_time = new Date(minEndDateTime.value)
    let year = end_date_time.getFullYear() + 1
    let this_month = end_date_time.getMonth() + 1
    let month = this_month.toString().padStart(2, "0")
    let date = end_date_time.getDate().toString().padStart(2, "0")
    let hour = end_date_time.getHours().toString().padStart(2, "0")
    let minutes = end_date_time.getMinutes().toString().padStart(2, "0")
    let max_end_date = `${year}-${month}-${date}T${hour}:${minutes}`
    return max_end_date
  })

  // 入力された値が登録済みの値と同じかどうかを判定する
  const hasUpdated = computed(() => {
    if (isFetchedHomework.value) {
      return (
        !isEqualArray(selectedClassrooms.value, homework.value.classroom_uuids) ||
        name.value !== homework.value.name ||
        message.value !== homework.value.message ||
        startDateTime.value !== getDefaultStartDateTime() ||
        endDateTime.value !== getDefaultEndDateTime() ||
        !isEqualArray(selectedQuestionSetIds.value, homework.value.question_set_ids) ||
        selectedAchievementCondition.value !== homework.value.achievement_condition ||
        relearningRequired.value !== homework.value.relearning_required
      ) ? true : false
    }
  })

  onMounted(async() => {
    await PrepareForSelected()
    // 宿題情報編集後にナビゲーションメニューでページ遷移する場合は離脱注意モーダルを表示
    let navs = document.querySelector(".l-navigation__body")
    let navItems = navs.querySelectorAll("a")
    navItems.forEach(function(item) {
      item.addEventListener('click', openMoveToNavMenuPageConfirmModal)
      }
    )
  
    // 宿題情報編集後にサイトロゴを押下した場合は離脱注意モーダルを表示
    let siteLogo = document.querySelector("#site-logo")
    siteLogo.addEventListener('click', openMoveToNavMenuPageConfirmModal)
  
    // 宿題情報編集後にログアウトボタン押下した場合は離脱注意モーダルを表示
    let logout = document.querySelector("#logout")
    logout.addEventListener('click', openMoveToNavMenuPageConfirmModal)
  })


  // 登録済みの宿題情報を取得する
  async function PrepareForSelected() {
    let path = window.location.pathname
    let homeworkId = path.match(/\d+/)
    homework.value = await homeworkStore.fetchHomework(homeworkId)

    // 年度
    academicYearsClassrooms.value = await learningProgressStore.fetchYearClass();
    academicSessionId.value = homework.value.academic_session_id

    // 学年一覧
    academicYears.value = academicYearsClassrooms.value.academicYears[academicSessionId.value] || []
    selectedAcademicYear.value = homework.value.academic_year

    // 宿題作成時の年度と学年に紐付く学級一覧
    classrooms.value = academicYearsClassrooms.value.classrooms[academicSessionId.value]? academicYearsClassrooms.value.classrooms[academicSessionId.value][selectedAcademicYear.value] || [] : []
    selectedClassrooms.value = homework.value.classroom_uuids
    // NFR-7417: 既割当の学級を記録（生徒0人でも選択可能なままにするため）
    initiallySelectedClassrooms.value = new Set(homework.value.classroom_uuids)
    selectClassroom()

    // 宿題名
    name.value = homework.value.name

    // 生徒向けメッセージ
    message.value = homework.value.message

    // 教科一覧
    await fetchSubjects()

    // 教材一覧
    await fetchWorkIDs()

    // 出題範囲
    selectedQuestionSetIds.value = homework.value.question_set_ids

    // 再学習指示
    relearningRequired.value = homework.value.relearning_required

    // 達成条件
    selectedAchievementCondition.value = homework.value.achievement_condition

    // 開始日時・終了日時
    startDateTime.value = getDefaultStartDateTime()
    endDateTime.value = getDefaultEndDateTime()

    isFetchedHomework.value = true
  }

  // NFR-7417: 学級が選択可能か（生徒が登録済み、または既に宿題へ割り当て済み）
  function isClassroomSelectable(classroom: IYearClassClassroom): boolean {
    return classroom.has_students || initiallySelectedClassrooms.value.has(classroom.value)
  }

  // NFR-7417: 選択可能な学級のみを返す
  function selectableClassrooms(): Array<IYearClassClassroom> {
    return (classrooms.value ?? []).filter(isClassroomSelectable)
  }

  // 「全学級」選択時
  function toggleAllClassrooms() {
    if (isAllSelected.value) {
      selectedClassrooms.value = []
      isAllSelected.value = false
    } else {
      // NFR-7417: 選択不可の学級は選択対象に含めない
      selectedClassrooms.value = selectableClassrooms().map((classroom) => classroom.value)
      isAllSelected.value = true
    }
  }

  // 個々の学級選択時
  function selectClassroom() {
    // すべての「選択可能な学級」が選択されたら「全学級」にチェックを入れる
    // そうでない場合は「全学級」のチェックを外す
    // NFR-7417: 選択不可の学級は母数から除外する（0件のときは誤ONを防ぐ）
    const selectableCount = selectableClassrooms().length
    if (selectableCount > 0 && selectedClassrooms.value.length === selectableCount) {
      isAllSelected.value = true
    } else {
      isAllSelected.value = false
    }
  }

  // 教科一覧取得
  async function fetchSubjects() {
    await workStore.fetchAvailableWorksBySubject(
      {
        academic_session_id: academicSessionId.value,
        academic_year: selectedAcademicYear.value,
      }
    )
    const newSubjects = workStore.availableWorksBySubject(academicSessionId.value, selectedAcademicYear.value) ?? []
    subjects.value = newSubjects.filter(subject => subject.has_license === true)
    selectedSubjectId.value = homework.value.subject_id || ''
  }

  // 教材一覧取得を取得する
  async function fetchWorkIDs() {
    works.value = await homeworkStore.fetchWorks({work_ids: [homework.value.work_id]})
    selectedWorkId.value = works.value[0].value
  }

  // 宿題範囲選択を表示、宿題作成画面を非表示
  function showScopeSelection() {
    isShowScopeSelection.value = true
  }

  // 宿題範囲選択を非表示、宿題作成画面を表示
  function hideScopeSelection() {
    isShowScopeSelection.value = false
  }

  function clearScope() {
    selectedQuestionSetIds.value = []
  }

  // 宿題範囲選択画面.宿題作成に戻るボタン押下時
  function resetScope() {
    hideScopeSelection()
    clearScope()
  }

  // 宿題範囲選択画面.出題範囲を決定するボタン押下時
  function fixScope() {
    hideScopeSelection()
  }

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // 登録済みの開始日時をデフォルトで設定する
  function getDefaultStartDateTime() {
    // // 2023-06-06T08:00 の形式にする
    let startDatetime = homework.value.start_datetime.replace("Z", "+09:00")
    let date = new Date(startDatetime)
    let year = date.getFullYear()
    let this_month = date.getMonth() + 1
    let month = this_month.toString().padStart(2, "0")
    let day = date.getDate().toString().padStart(2, "0")
    let hour = date.getHours().toString().padStart(2, "0")
    let min = date.getMinutes().toString().padStart(2, "0")
    let defaultStartDatetime = `${year}-${month}-${day}T${hour}:${min}`
    return defaultStartDatetime
  }

  // FIXME: 共通している日付周りの処理はメソッドに切り出す (NFR-4169)
  // 登録済みの開始日時をデフォルトで設定する
  function getDefaultEndDateTime() {
    // 2023-06-06T08:00 の形式にする
    let endDatetime = homework.value.end_datetime.replace("Z", "+09:00")
    let date = new Date(endDatetime)
    let year = date.getFullYear()
    let this_month = date.getMonth() + 1
    let month = this_month.toString().padStart(2, "0")
    let day = date.getDate().toString().padStart(2, "0")
    let hour = date.getHours().toString().padStart(2, "0")
    let min = date.getMinutes().toString().padStart(2, "0")
    let defaultEndDatetime = `${year}-${month}-${day}T${hour}:${min}`
    return defaultEndDatetime
  }

  function moveToHomeworkList(message: string) {
    const currentUrl = window.location.href
    window.location.href = `${currentUrl.replace("homework/" + homework.value.id + "/edit/", "homework/")}?${INFOTOAST_MESSAGE_PARAMNAME}=${message}`
  }

  // 更新ボタン押下時
  async function updateHomework() {
    // 必須項目がすべて入力されている場合にPOSTする
    if (!(
      selectedClassrooms.value.length !== 0 &&
      name.value &&
      startDateTime.value &&
      endDateTime.value &&
      selectedQuestionSetIds.value.length > 0 &&
      selectedAchievementCondition.value)) {
        return alert("必須項目を入力してください")
      }
    openUploadInProgressModal()
    homeworkUpdateResult.value = await homeworkStore.fetchHomeworkUpdate(
      {
        classroom_uuids: selectedClassrooms.value,
        name: name.value,
        message: message.value,
        question_set_ids: selectedQuestionSetIds.value,
        start_datetime: startDateTime.value,
        end_datetime: endDateTime.value,
        achievement_condition: selectedAchievementCondition.value,
        relearning_required: relearningRequired.value,
        homeworkId: homework.value.id,
      },
    )
    if (homeworkUpdateResult.value) {
      moveToHomeworkList(homeworkUpdateResult.value.message)
    }
    closeUploadInProgressModal()
  }

  function openUploadInProgressModal() {
    isOpenAddInProgressModal.value = true
  }

  function closeUploadInProgressModal() {
    isOpenAddInProgressModal.value = false
  }

  function isEqualArray(array1, array2) {
    let i = array1.length
    if (i != array2.length) {
      return false
    }
    array1.sort()
    array2.sort()
    while (i--) {
      if (array1[i] !== array2[i]) {
          return false;
      }
    }
    return true;
  }

  // 遷移先の設定
  function movePage() {
    window.location.href = location.value
    closeMovePageConfirmModal()
  }

  // 戻るボタン押下時
  function openBackToHomeworkListConfirmModal() {
    const homeworkListUrl = "/teacher/homework/"
    if (hasUpdated.value) {
      location.value = homeworkListUrl
      isOpenMovePageConfirmModal.value = true
    } else {
      window.location.href = homeworkListUrl
    }
  }

  // ナビゲーションメニュー押下時
  function openMoveToNavMenuPageConfirmModal(event) {
    if (hasUpdated.value) {
      event.preventDefault()
      location.value = event.currentTarget.href
      isOpenMovePageConfirmModal.value = true
    }
  }

  function closeMovePageConfirmModal() {
    isOpenMovePageConfirmModal.value = false
  }
</script>

<style scoped>
/* NFR-7417: 生徒未登録の学級を選択不可にし、ホバーで理由をツールチップ表示する */
.class-item.is-disabled {
  position: relative;
  cursor: not-allowed;
}
/* 非活性の学級名・チェックボックスをグレーアウト */
.class-item.is-disabled .c-form-checkbox-label {
  color: #999;
}
.class-item.is-disabled .c-form-checkbox-label::before {
  background: #f0f0f0;
  border-color: #ddd;
}
/* ホバーで表示する理由ツールチップ（黒背景の吹き出し） */
.p-homework-form__class-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 10;
  width: max-content;
  max-width: 260px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 1.2rem;
  line-height: 1.5;
  white-space: normal;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}
.p-homework-form__class-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 16px;
  border: 6px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}
.class-item.is-disabled:hover .p-homework-form__class-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>
